module.exports = __webpack_public_path__ + "img/safari_tips_jp.9dd97f51.png";